var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrrowDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48179 2.00598L1.48185 2.00602C1.3932 2.09901 1.34375 2.22255 1.34375 2.35102C1.34375 2.47947 1.39318 2.603 1.4818 2.69598L1.48179 2.00598ZM1.48179 2.00598L1.48601 2.00175L1.48716 2.0006L1.48179 2.00598ZM4.1368 5.48247L1.48185 2.69602L4.86079 5.48248C4.8141 5.53149 4.75793 5.57051 4.69571 5.59717L4.59725 5.36737L4.69571 5.59717C4.63349 5.62383 4.56649 5.63757 4.4988 5.63757C4.4311 5.63757 4.36411 5.62383 4.30188 5.59717C4.23966 5.57051 4.1835 5.53149 4.1368 5.48248C4.1368 5.48248 4.1368 5.48247 4.1368 5.48247ZM7.51575 2.69602L4.8608 5.48247L1.9993 2.17552L2.1803 2.00308L2.18043 2.00321C2.18047 2.00325 2.18051 2.0033 2.18055 2.00334L4.49926 4.43706L6.81705 2.00334C6.81709 2.00329 6.81713 2.00325 6.81717 2.0032C6.86199 1.95606 6.91592 1.91852 6.97569 1.89287L7.07431 2.12259L6.97569 1.89286C7.03551 1.86718 7.09994 1.85394 7.16505 1.85394C7.23015 1.85394 7.29458 1.86718 7.3544 1.89286L7.25578 2.12259L7.3544 1.89287C7.41307 1.91805 7.4661 1.95468 7.51042 2.0006L7.51157 2.00175L7.51162 2.0017L7.51575 2.00602C7.60439 2.09901 7.65384 2.22255 7.65384 2.35102C7.65384 2.47947 7.60441 2.603 7.51579 2.69598C7.51578 2.69599 7.51576 2.69601 7.51575 2.69602Z",
    fill: "#181038",
    stroke: "#181038",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowDownSmall);
export default __webpack_public_path__ + "static/media/arrrow-down-small.623c6db9f71a235548a8849502f59c2c.svg";
export { ForwardRef as ReactComponent };